module.exports = __webpack_public_path__ + "static/media/bannerImage2-s.701939b4.jpg";